import { Telegram } from '@mui/icons-material';
import { Bell } from 'lucide-react';
import React from 'react';
import { FaDownload } from 'react-icons/fa';

function MedilogyApp() {
    return (
        <div className="min-h-screen bg-gradient-to-br mt-14 from-purple-100 via-pink-50 to-orange-100 flex flex-col items-center justify-center p-4 md:p-6 relative overflow-hidden">
            {/* Background Gradient Circle */}
            <div className="absolute top-1/2 left-1/2 w-[500px] md:w-[700px] h-[500px] md:h-[700px] bg-gradient-to-br from-pink-400 to-purple-600 opacity-30 rounded-full transform -translate-x-1/2 -translate-y-1/2 blur-3xl pointer-events-none" />

            {/* Main Content */}
            <div>
                {/* Left Side - Text & QR */}
                <div className="relative z-10 flex flex-col-reverse md:flex-row items-center justify-between w-full max-w-6xl gap-10 bg-white/80 backdrop-blur-lg rounded-3xl p-6 md:p-10 shadow-2xl">
                    <div className="text-center md:text-left w-full max-w-xl">
                        <h1 className="text-7xl md:text-4xl font-extrabold text-gray-900 mb-4">
                            মেডিলজি মোবাইল অ্যাপ
                        </h1>
                        <h2 className="text-2xl md:text-2xl font-semibold text-purple-700 mb-6">
                            মেডিকেল প্রস্তুতি দেশের একমাত্র ডিজিটাল লার্নিং অ্যাপ
                        </h2>


                        <p className="text-black text-xl mb-4 leading-relaxed">
                            পড়াশোনা হবে ডিস্ট্র্যাকশন ছাড়া, ডাক্তার হওয়ার স্বপ্ন পূরণ করবে মেডিলজি। মেডলজিয়ানদের মোবাইল অ্যাপে যুক্ত হবে মেডিলজি অ্যাপ। প্রথম ভার্সনে অ্যাপেই লাইভ ক্লাস করতে পারবে, রেকর্ড ক্লাস করতে পারবে। মোবাইল অ্যাপে ক্লাস করার নতুন অভিজ্ঞতা পাবে মেডিলজিয়ানরা। পরবর্তী ভার্সনে পরীক্ষা আপডেট করা হবে।
                        </p>
                        {/* Download Button */}
                        <div className="mb-6 flex justify-center md:justify-start mt-2">
                            <a
                                href="/Medilogy Mobile.apk"
                                download
                                className="bg-purple-600 hover:bg-purple-700 text-white font-medium px-6 py-3 rounded-full flex items-center gap-2 shadow-md transition duration-200"
                            >
                                <FaDownload className="text-lg" />
                                <span>Download Apk</span>
                            </a>
                        </div>
                        {/* Notice Text */}
                        <h1>যেকোন সমস্যায় যুক্ত হও টেলিগ্রাম <a href='https://t.me/+N3awag5ITHQxNDY1'><Telegram className="inline-block text-lg" /></a> </h1>
                    </div>

                    {/* Right Side - Phone Mockups */}
                    <div className="flex gap-4 md:gap-6 justify-center">
                        <div className="w-36 md:w-40 h-72 md:h-80 bg-black rounded-3xl border-[6px] border-gray-900 relative overflow-hidden shadow-xl hover:scale-105 transition">
                            <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-10 h-1.5 bg-gray-400 rounded-full"></div>
                            <img
                                className="h-full w-full object-cover"
                                src="https://i.ibb.co/6ccRP7bC/6053249701106535098-1.jpg"
                                alt="Phone Mockup 1"
                            />
                        </div>
                        <div className="w-36 md:w-40 h-72 md:h-80 bg-black rounded-3xl border-[6px] border-gray-900 relative overflow-hidden shadow-xl hover:scale-105 transition">
                            <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-10 h-1.5 bg-gray-400 rounded-full"></div>
                            <img
                                className="h-full w-full object-cover"
                                src="https://i.ibb.co/xKfbk2ts/6053249701106535097.jpg"
                                alt="Phone Mockup 2"
                            />
                        </div>
                    </div>
                </div>

            </div>

            {/* Download Button */}
            <div className="flex text-2xl justify-center mt-10 ">
                <p className="text-xl text-black">

                    <strong><Bell className="inline-block text-xs" /></strong> অ্যাপ ইন্সটল করার সময় Scan Notification আসলে <strong>More Details</strong> এ ক্লিক করে <strong>Install Without Scanning</strong> অপশনে ক্লিক করবে।<br />
                    প্রথম ভার্সন অ্যান্ড্রয়েড এর জন্য লঞ্চ করা হল। খুব দ্রুত আমরা অ্যাপল স্টোরে পাবলিশ করব, তখন আইফোন ইউজাররা ইন্সটল করে নিবে।
                </p>

            </div>
            <div className='flex justify-center'>
                <img className='w-1/2' src="lv_0_20250722230811.gif"></img>
            </div>
        </div>
    );
}

export default MedilogyApp;
